import styled, { css } from "styled-components";
import { getPropertyByMedia, getThemeFont, getThemeMedia, getThemeSpace } from "../../../components/helpers";
export const Container = styled.div `
	transition: height 300ms ease-in-out;
	position: relative;
	${({ width }) => getPropertyByMedia("width", width, "100%")}
	display: flex;
	flex-direction: column;
	gap: ${getThemeSpace("4")};

	${({ hasFooter }) => hasFooter &&
    css `
			margin-bottom: ${getThemeSpace("16")};
		`}
	
		${({ selectType }) => selectType === 'boxless' &&
    css `
			flex-direction: row;
			align-items: center;

			gap: 4px;

			p {
				color: var(--text-secondary);
			}

			button {
				border: none;
				padding: 0;
				font-weight: bold;
				color: var(--text-primary) !important;
				
				span {
					font-weight: bold;
					color: var(--text-primary);
				}

				i {
					color: var(--text-link);
					font-size: 20px;
				}
			}
		`}
`;
export const LabelWrapper = styled.div `
	display: flex;
	flex-direction: column;
	gap: ${getThemeSpace("2")};
`;
export const FeedbackWrapper = styled.p `
	display: flex;
	align-items: center;
	gap: ${getThemeSpace("4")};
	line-height: 16px;
`;
export const IconWrapper = styled.div `
	display: flex;
	align-items: center;
	justify-content: center;
	cursor: ${({ cursor }) => cursor || "initial"};
	user-select: none;
	height: 100%;
	width: 48px;
	padding: 0 12px;

	position: absolute;
	${({ position }) => css `
		${position}: 0;
	`}
`;
export const LengthMessage = styled.div `
	line-height: 1;
	position: absolute;
	right: 0;
	bottom: -20px;
`;
export const FooterWrapper = styled.footer `
	width: 100%;
	color: var(--text-primary);
	font-family: ${getThemeFont("sourceSansPro")};
	margin-top: ${getThemeSpace("8")};
	position: absolute;
	top: 75px;
	right: 0;

	&:not(.without-message) {
		margin-top: 30px;
	}

	@media screen {
		@media (min-width: ${getThemeMedia("medium")}) {
			&:not(.without-message) {
				margin-top: 55px;
			}
		}
	}
`;
export const FieldWrapper = styled.div `
	position: relative;
	display: flex;
	align-items: center;
	justify-content: center;
`;
//# sourceMappingURL=styles.js.map